import { isMVPDSSOEnabled } from 'helpers/ConfigHelper';
import MVPDSSO from './views/MVPDSSO';
import Legacy from './views/Legacy';

export default isMVPDSSOEnabled() ? MVPDSSO : Legacy;
